<script>
  import fileTemplateState from "../../stores/fileTemplateJsonData"
  /**
   * @type {Array} list of font family names
   */
  export let dropdownItems

  /**
   * @type {String} - The currently active item.
   */

  export let activeItem = "Arial"

  /**
   * @type {HTMLElement} binded the overall dropdown parent element
   */
  let dropdown
  let focusInput
  /**
   * @type {boolean} toggling the dropdown to show and hide
   */
  let showDropdown = false

  /**
   * @type {Array} Array of filtered items
   */
  let filteredItems = []

  let hideDropdownInitially = true

  /**
   * Handles the close event of the dropdown.
   *
   * @param {Event} e - The event object.
   */
  const onCloseDropDown = (e) => {
    // Check if the event target is not within the dropdown
    if (dropdown.contains(e.target) == false) {
      showDropdown = false
    }

    // If the dropdown is not shown and there is no active item
    if (!showDropdown && !activeItem) {
      activeItem = "Arial"
    }
  }

  /**
   * Performs a search for items based on the active item.
   * Updates the state variables to show the dropdown and filter the items.
   */
  const searchItem = () => {
    if (!hideDropdownInitially) {
      // Set showDropdown to true to display the dropdown
      showDropdown = true

      // Filter the dropdownItems based on the activeItem
      filteredItems = dropdownItems.filter((item) => item.toLowerCase().match(activeItem.toLowerCase()))
    }
  }

  $: searchItem(activeItem)
</script>

<svelte:window on:click={onCloseDropDown} />
<div class="relative w-full" bind:this={dropdown}>
  <div class="group relative w-full rounded-md">
    <!-- <div class="absolute left-3 top-2 select-none text-sm font-bold text-gray-g00 group-focus-within:text-extraBlue-500">ATTRIBUTE</div> -->
    <input
      style="font-family: {activeItem};"
      on:input={() => {
        hideDropdownInitially = false
        if (!dropdownItems.includes(activeItem)) {
          activeItem = "Arial"
        }
      }}
      on:keydown={(e) => {
        if (e.key == "Delete") {
          e.stopPropagation()
        }
      }}
      bind:this={focusInput}
      bind:value={activeItem}
      type="text"
      class="relative w-full rounded-md border border-stone-700 bg-transparent py-2 pl-5 pr-8 text-sm font-bold text-white shadow-sm outline-none focus:text-blue-500 focus:ring-2 focus:ring-extraBlue-500"
    />
    <div class="absolute right-3 top-2 select-none text-sm font-bold text-white group-focus-within:text-extraBlue-500">
      <button
        on:click={() => {
          focusInput.focus()
          filteredItems = []
          showDropdown = !showDropdown
          if (!showDropdown && !activeItem) {
            activeItem = "Arial"
          }
        }}
      >
        <i class="fa-solid fa-chevron-down" />
      </button>
    </div>
  </div>
  <ul class:hidden={!showDropdown} style="padding-inline-start:0px;" class="absolute z-10 mt-2 max-h-40 w-full flex-col overflow-auto rounded-md border border-none bg-gray-f00 text-sm ring-2 focus:outline-none" tabindex="-1">
    {#if filteredItems.length > 0}
      {#each filteredItems as item}
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <li
          on:click={(e) => {
            activeItem = item
            $fileTemplateState.activeFontFamily = item
            showDropdown = false
          }}
          style="font-family: '{item}';"
          class="cursor-pointer select-none rounded-md bg-transparent py-2 pl-3 pr-9 text-sm text-gray-g00 hover:bg-gray-e00 hover:text-extraBlue-500"
        >
          {item}
        </li>
      {/each}
    {:else}
      {#each dropdownItems as item}
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <li
          on:click={(e) => {
            activeItem = item
            $fileTemplateState.activeFontFamily = item
            showDropdown = false
          }}
          style="font-family: '{item}';"
          class="{activeItem == item ? 'bg-gray-e00 text-white' : ''} cursor-pointer select-none rounded-md bg-transparent py-2 pl-3 pr-9 text-left text-sm text-gray-g00 hover:bg-gray-e00 hover:text-extraBlue-500"
        >
          {item}
        </li>
      {/each}
    {/if}
  </ul>
</div>
